module.exports = __webpack_public_path__ + "media/img/frontend_application/banner-post-enquiry-8485535cbff5ede2418f3f4b2de547b1.png";